export default __webpack_public_path__ + "static/media/clouds.566a4a56.jpg";